import { MutationTree } from 'vuex';
import { UsersState } from './types';
import { UserResource } from '@/api/requests/types';

export const mutations: MutationTree<UsersState> = {
    /**
     * Add a user to the list.
     *
     * @param state
     * @param user
     */
    addUser(state, user: UserResource) {
        const index = state.users.findIndex((item) => item.id === user.id);
        if (index > -1) {
            state.users.splice(index, 1, user);
        } else {
            state.users.push(user);
        }
    },

    /**
     * Remove a user from the list.
     *
     * @param state
     * @param userId
     */
    removeUser(state, userId) {
        state.users = state.users.filter((user) => user.id !== userId);
    },

    /**
     * Reset the active user id.
     *
     * @param state
     */
    resetActiveUserId(state) {
        state.activeUserId = null;
    },

    /**
     * Reset the users list.
     *
     * @param state
     */
    resetUsers(state) {
        state.users = [];
    },

    /**
     * Set the active user id.
     *
     * @param state
     * @param id
     */
    setActiveUserId(state, id: number) {
        state.activeUserId = id;
    },

    /**
     * Set the users list.
     *
     * @param state
     * @param users
     */
    setUsers(state, users) {
        state.users = users;
    },

    /**
     * Set the available related users list.
     *
     * @param state
     * @param users
     */
    setRelatedUsers(state, relatedUsers) {
        state.relatedUsers = relatedUsers;
    },

    /**
     * Set the available related users list.
     *
     * @param state
     * @param users
     */
    setAvailableRelatedUsers(state, availableRelatedUsers) {
        state.availableRelatedUsers = availableRelatedUsers;
    },

    
};
